//      
import React from 'react';
import { css } from 'styled-components';

import dates from 'utils/dates';

const dateStyle = css`
    &:hover {
        cursor: cell;
    }
`;

                                  
                                 
                   
                       
  

export const FormattedDate = ({
    date,
    format,
    helpFormat,
    ...spanProps
}                    ) => {
    return (
        <span
            css={dateStyle}
            className='date-component'
            title={dates.formatDate(date, helpFormat)}
            {...spanProps}
        >
            {dates.formatDate(date, format)}
        </span>
    );
};

FormattedDate.defaultProps = {
    format: 'll',
    helpFormat: 'LLLL',
};

export default FormattedDate;
